import { render, staticRenderFns } from "./DirectOrdersList.vue?vue&type=template&id=94aeaa8c&scoped=true"
import script from "./DirectOrdersList.vue?vue&type=script&lang=js"
export * from "./DirectOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aeaa8c",
  null
  
)

export default component.exports